import {
  NATIVE_TITLE_SIZE,
  v2Text,
  v2TextWithPetName,
} from '@flows/configs/petHealthV2/steps/elements/shared'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { ElementFragment } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'
import { BaseSchema_PetHealthV2GetsafeDe } from '@flows/insurance/schemas'

export const petGenderElements = (params: StepConfigParams) =>
  ({
    elements: [
      {
        type: 'title',
        text: v2TextWithPetName(params, 'steps.pet_gender.title'),
        size: NATIVE_TITLE_SIZE,
      },
      {
        type: 'radioCardSet',
        shouldTrackValues: true,
        layout: 'wide',
        variant: 'chip',
        name: params.helperFunctions.getParamPath('pet_gender'),
        options: [
          {
            value: 'male',
            title: v2Text('steps.pet_gender.male'),
            icon: { name: 'GenderMale' },
          },
          {
            value: 'female',
            title: v2Text('steps.pet_gender.female'),
            icon: { name: 'GenderFemale' },
          },
        ],
      },
    ],
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('pet_gender')]:
        BaseSchema_PetHealthV2GetsafeDe.shape.pet_gender.unwrap(),
    }),
  }) as const satisfies ElementFragment
